import React from "react";

export function Packages() {


    return (
        <div>
            <div className={"row my-5"}>
                Under construction
            </div>
        </div>
    )
}